import { COMPONENT_VALUE_TYPES as types, FONT_FAMILIES,FONT_FAMILY_ROBOTO} from 'shared/constants';

const propsSchema = [
  {
    key: 'label',
    label: 'Label',
    type: types.OBJECT,
    children: [
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
      },
      {
        key: 'font',
        label: 'Font Family',
        type: types.ENUM,
        options: FONT_FAMILIES
      },
      {
        key: 'color',
        label: 'Color',
        type: types.COLOR_PICKER
      },
      // TODO: The Label widget will support animation in the future.
      // {
      //   key: 'animation',
      //   label: 'Animation',
      //   type: types.BOOLEAN,
      // },
      {
        key: 'responsive',
        label: 'Responsive',
        type: types.OBJECT,
        children: [
          {
            key: 'desktop',
            label: 'Desktop',
            type: types.OBJECT,
            children: [
              {
                key: 'padding',
                label: 'Padding',
                type: types.TEXT
              },
              {
                key: 'font_size',
                label: 'Font Size',
                type: types.TEXT
              },
              {
                key: 'font_weight',
                label: 'Font Weight',
                type: types.TEXT
              },
              {
                key: 'letter_spacing',
                label: 'Letter Spacing',
                type: types.TEXT
              },
              {
                key: 'line_height',
                label: 'Line Height',
                type: types.TEXT
              },
            ]
          },
          {
            key: 'tablet',
            label: 'Tablet',
            type: types.OBJECT,
            children: [
              {
                key: 'padding',
                label: 'Padding',
                type: types.TEXT
              },
              {
                key: 'font_size',
                label: 'Front Size',
                type: types.TEXT
              },
              {
                key: 'font_weight',
                label: 'Front Weight',
                type: types.TEXT
              },
              {
                key: 'letter_spacing',
                label: 'Letter Spacing',
                type: types.TEXT
              },
              {
                key: 'line_height',
                label: 'Line Height',
                type: types.TEXT
              },
            ]
          },
          {
            key: 'mobile',
            label: 'Mobile',
            type: types.OBJECT,
            children: [
              {
                key: 'padding',
                label: 'Padding',
                type: types.TEXT
              },
              {
                key: 'font_size',
                label: 'Front Size',
                type: types.TEXT
              },
              {
                key: 'font_weight',
                label: 'Front Weight',
                type: types.TEXT
              },
              {
                key: 'letter_spacing',
                label: 'Letter Spacing',
                type: types.TEXT
              },
              {
                key: 'line_height',
                label: 'Line Height',
                type: types.TEXT
              },
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'container',
    label: 'Container',
    type: types.OBJECT,
    children: [
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT
      },
      {
        key: 'height',
        label: 'height',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  label: {
    text: 'Label',
    font: FONT_FAMILY_ROBOTO,
    color: 'gray',
    animation: false,
    responsive: {
      desktop:{
        padding: '4px',
        font_size: '40px',
        font_weight: 'inherit',
        letter_spacing: '0px',
        line_height: '1em'
      },
      tablet:{
        padding: '3px',
        font_size: '30px',
        font_weight: 'inherit',
        letter_spacing: '0px',
        line_height: '1em'
      },
      mobile:{
        padding: '2px',
        font_size: '20px',
        font_weight: 'inherit',
        letter_spacing: '0px',
        line_height: '1em'
      },
    }
  },
  container: {
    width: 'auto',
    height: 'auto'
  }
}

export default {
  title: 'Label',
  id: 'Label',
  widgetImage: '/widgetImages/Rich+text.png',
  basic: true,
  propsSchema,
  defaultProps
};
